<div class="section bg-primary text-center">
    <div class="container">
        <h3 class="text-white pb-5">Interessado em uma solução de gestão empresarial para sua empresa?</h3>
        <a class="btn btn-outline-light btn-outline-white btn-lg" [routerLink]="" (click)="solicitarOrcamento()">Solicite Orçamento</a>
    </div>
</div>
